var exports = {
  "socials": "x9bf38834--cba8bd--socials",
  "social-item": "x9bf38834--cba8bd--social-item",
  "phone": "x9bf38834--cba8bd--phone",
};

module.exports = exports;
